import React from 'react';
import { R, SHADCN } from '../theme';

// Bloc gris pâle animé en pulse — unique loader contenu de l'app.
// Usage : <Skeleton h={80} /> ou <Skeleton h={160} lines={3} />
// `lines` répète le bloc verticalement avec un gap.
//
// L'animation `sk-pulse` (définie dans theme.js) fait osciller l'opacity
// entre 0.55 et 0.95 sur 2.4s — soft, lent, élégant.
export default function Skeleton({
  h = 16,
  w = '100%',
  radius = R.md,
  lines = 1,
  gap = 10,
  style,
}) {
  const block = (key) => (
    <div
      key={key}
      style={{
        height: h,
        width: w,
        background: SHADCN.muted,
        borderRadius: radius,
        animation: 'sk-pulse 1.8s cubic-bezier(0.23, 1, 0.32, 1) infinite',
      }}
    />
  );

  if (lines <= 1) return <div style={style}>{block(0)}</div>;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap, ...style }}>
      {Array.from({ length: lines }, (_, i) => block(i))}
    </div>
  );
}
